
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-studies/cooperative-learning-boosts-success",
      function () {
        return require("private-next-pages/research-studies/cooperative-learning-boosts-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-studies/cooperative-learning-boosts-success"])
      });
    }
  